import { Box, Button, TextField, Typography } from "@mui/material";
import { LoadingComponent } from "../../helpers";
import { PasswordResetProps } from "./passwordreset.types";
import { usePasswordResetViewModel } from "./passwordreset.vm";
import "./passwordreset.css";

export function PasswordReset(props: PasswordResetProps) {
	const vm = usePasswordResetViewModel(props);

	// Render password update form (with valid token)
	if (vm.isTokenValid) {
		return (
			<Box
				maxWidth="md"
				margin="auto"
				component="form"
				noValidate
				className="password-reset-form"
				onSubmit={vm.handlePasswordUpdate}
			>
				{vm.loading && (
					<Box display="flex" justifyContent="center" alignItems="center">
						<LoadingComponent />
					</Box>
				)}
				<TextField
					variant="outlined"
					margin="normal"
					error={!!vm.passwordError}
					helperText={vm.passwordError}
					required
					disabled={vm.loading}
					fullWidth
					name="password"
					label="New Password"
					type="password"
					id="password"
					autoComplete="current-password"
					onChange={vm.handlePasswordChange}
					onBlur={vm.handlePasswordChange}
					data-sentry-component="New Password Field"
				/>
				<TextField
					variant="outlined"
					margin="normal"
					error={!!vm.confirmPasswordError}
					helperText={vm.confirmPasswordError}
					required
					disabled={vm.loading}
					fullWidth
					name="Confirm password"
					label="Confirm Password"
					type="password"
					id="Confirm password"
					autoComplete="confirm-password"
					onChange={vm.handleConfirmPasswordChange}
					onBlur={vm.handleConfirmPasswordChange}
					data-sentry-component="Confirm Password Field"
				/>
				{vm.error && (
					<Typography variant="body2" color="textSecondary" align="center" className="error-message">
						{vm.error}
					</Typography>
				)}
				<Typography className="instruction-text">Please enter your new password.</Typography>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					className="submit-button"
					data-sentry-component="Submit Button"
				>
					Update Password
				</Button>
			</Box>
		);
	} else {
		// Render password reset request form (no token)
		return (
			<Box
				maxWidth="md"
				margin="auto"
				component="form"
				noValidate
				className="password-reset-form"
				onSubmit={vm.handlePasswordReset}
			>
				{vm.loading && (
					<Box display="flex" justifyContent="center" alignItems="center">
						<LoadingComponent />
					</Box>
				)}
				<TextField
					margin="normal"
					required
					id="email"
					label="Email Address"
					name="email"
					autoComplete="email"
					autoFocus
					error={!!vm.emailError}
					helperText={vm.emailError}
					onChange={vm.handleEmailChange}
					onBlur={vm.handleEmailChange}
					data-sentry-component="Email Field"
				/>
				{vm.error && (
					<Typography variant="body2" color="textSecondary" align="center" className="error-message">
						{vm.error}
					</Typography>
				)}
				<Typography className="instruction-text">Please enter the email associated with your Rogo Account.</Typography>
				<Button
					type="submit"
					fullWidth
					variant="contained"
					className="submit-button"
					data-sentry-component="Submit Button"
				>
					Reset Password
				</Button>
			</Box>
		);
	}
}
